export const smtfOptions = Object.freeze([
  {
    value: "0",
    heading:
      "Automatic movement of funds from Normal to SMTF ledger upto SMTF debit amount.",
    description:
      "Any excess funds available in normal ledger will get transferred to SMTF ledger to the extent of excess funds available in normal ledger and to the extent of debit in SMTF ledger. This preference helps you save interest in SMTF ledger as SMTF debit gets reduced automatically whenever there is excess credit available in the normal ledger",
  },
  {
    value: "1",
    heading:
      "Automatic movement of funds from Normal to SMTF ledger upto SMTF margin requirement.",
    description:
      "Any excess funds available in normal ledger will get transferred to SMTF ledger to the extent of excess funds available in normal ledger and to the extent of SMTF margin requirement only. Under this option, the SMTF debit will remain even in case you have excess credit available in Normal ledger and you will be levied interest on SMTF debit amount despite credit being available in Normal ledger.",
  },
]);

export const rmDetails = Object.freeze({
  name: "Arvind Kathappan",
  mailId: "helpdesk@nuvama.com",
});

export const smtfMsg = Object.freeze({
  error:
    "There was some problem in raising service request. Please try again later.",
  createSR: {
    headerText: "We have received your request!",
    content:
      "We have received your request for NRML-SMTF funds movement preference. This request will be processed by end of day.",
  },
});
